var map = {
	"./BOU/matrix_item.png": "261b",
	"./DRU/matrix_item.png": "24dc",
	"./FNB/matrix_item.png": "acf3",
	"./HIM/matrix_item.png": "517b",
	"./OTH/matrix_item.png": "d804",
	"./SUP/matrix_item.png": "36e2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8400";